<ul #tabContainer class="tabs" [ngClass]="{'wrap': wrap === true}">
  @for (tab of tabs; track tab) {
    <li [ngClass]="{active: tab === activeTab, disabled: tab.disabled}" id="{{tab.label}}">
      <ng-template #tabIcon>
        <span class="ng-value-icon tab-icon"
          [class.left]="tab.iconPosition === 'left'"
          [class.right]="tab.iconPosition === 'right'"
          [style.color]="tab.iconColor"
                [ngClass]="{
                    'label5': size === 5, 'label4': size === 4, 'label3': size === 3, 'label2': size === 2, 'label1': size === 1,
                    'icon-color-warn': tab.iconColorType === 'warn', 'icon-color-error': tab.iconColorType === 'error'
                }"
          (click)="close(tab)"
          aria-hidden="true">
          <rask-icon [icon]="tab.icon"></rask-icon>
        </span>
      </ng-template>
      @if (tab.icon && tab.iconPosition === 'left') {
        <ng-container *ngTemplateOutlet="tabIcon"></ng-container>
      }
      <div class="label"
        [ngClass]="{ 'label5': size === 5, 'label4': size === 4, 'label3': size === 3, 'label2': size === 2, 'label1': size === 1 }"
        (click)="selectTab(tab, true)"
        [disablePopover]="!tab.tooltipText"
        [ngbPopover]="onHover"
        [openDelay]="300"
        [closeDelay]="300"
        triggers="mouseenter:mouseleave"
        (mouseenter)="mouseEnterTab(tab)"
        (mouseleave)="mouseLeaveTab(tab)"
        container="body"
        popoverClass="rask-icon-popover"
        >
        {{tab.label}}
        @if (tab.spinner === true) {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
      </div>
      @if (tab.icon && tab.iconPosition === 'right') {
        <ng-container *ngTemplateOutlet="tabIcon"></ng-container>
      }
      @if (closable && !tab.lockedTab) {
        <span class="ng-value-icon right clear-icon"
            [ngClass]="{
                'label5': size === 5, 'label4': size === 4, 'label3': size === 3, 'label2': size === 2, 'label1': size === 1,
                'icon-color-warn': closeIconColor === 'warn', 'icon-color-error': closeIconColor === 'error'
            }"
          (click)="close(tab)"
          aria-hidden="true">
          <rask-icon [icon]="closeIcon"></rask-icon>
        </span>
      }
      <ng-template #onHover>
        {{tab.tooltipText}}
        <ng-content></ng-content>
      </ng-template>
      <div #templateResult style="display: none;">
        <ng-container *ngTemplateOutlet="onHover"></ng-container>
      </div>
    </li>
  }
</ul>

@for (tab of tabsWithBody(); track $index) {
  <div class="tab" [ngClass]="{hidden: tab !== activeTab}" [class]="tabClass">
    <ng-container *ngTemplateOutlet="tab.template"></ng-container>
  </div>
}
